import { render, staticRenderFns } from "./good-info.vue?vue&type=template&id=7577f5b1&scoped=true&"
import script from "./good-info.vue?vue&type=script&lang=js&"
export * from "./good-info.vue?vue&type=script&lang=js&"
import style0 from "./good-info.vue?vue&type=style&index=0&id=7577f5b1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7577f5b1",
  null
  
)

export default component.exports